// extracted by mini-css-extract-plugin
export var backdropBlur = "_cp-0";
export var contentCard = "_cp-5";
export var frame = "_cp-2";
export var image = "_cp-4";
export var imagePane = "_cp-3";
export var modal = "_cp-1";